/**
 * Order-trail comments after a successful reassignment.
 * @module reAssignModal/utils/insertReassignTrailComments
 */

import { insertOrderAssignedReassignedTrailComment } from "../../../../utils/orderTrailComment";

/** Parameters for {@link insertReassignTrailComments}. */
export interface InsertReassignTrailCommentsParams {
  /** Parent and sibling order ids that received the assignment update. */
  orderIds: string[];
  /** Organization id for trail comment persistence. */
  orgId: string;
  /** Patient id shared across linked DOS orders when available. */
  patientId?: string;
  /** Email of the user performing the reassignment. */
  providerEmail: string;
  /** Display name of the acting provider for the trail entry. */
  providerName: string;
  /** Assignee label before the change. */
  fromAssignee: string;
  /** Assignee label after the change. */
  toAssignee: string;
}

/**
 * Writes reassignment trail comments for each updated order id.
 *
 * @param params - Trail context shared across parent and sibling orders
 */
export const insertReassignTrailComments = (
  params: InsertReassignTrailCommentsParams,
): void => {
  params.orderIds.forEach((orderId) => {
    insertOrderAssignedReassignedTrailComment({
      orderId,
      orgId: params.orgId,
      patientId: params.patientId,
      providerEmail: params.providerEmail,
      providerName: params.providerName,
      fromAssignee: params.fromAssignee,
      toAssignee: params.toAssignee,
    });
  });
};
